<template>
  <footer class="footer">
    <div class="md-offset">
      <div class="footer-container">
        <div class="dev">
          Developed by
          <a href="https://www.yellows.pl" target="_blank">Yellows</a>
        </div>
        <div class="footer-links">
          <a :href="rulesUrl" target="_blank">Regulamin</a>
          <a :href="policyUrl" target="_blank">Polityka prywatności</a>
        </div>
        <div class="ml-auto dev">
          <span class="copyright"> {{ copyright }} &nbsp; </span>
        </div>
        <img src="/img/footer-logo.svg" alt="Discoveria" class="footer-logo" />
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Footer',
  computed: {
    ...mapState({
      rulesUrl: state => state.rulesDocUrl,
      policyUrl: state => state.policyDocUrl,
    }),
    copyright() {
      return `© ${new Date().getFullYear()} Discoveria`
    },
  },
}
</script>

<style scoped lang="scss">
.footer {
  background-color: #f5841f;
  color: #ffffff;
  padding: 0;
  font-size: 14px;
  font-weight: 400;
  flex: 0 0 auto;
  a {
    margin-left: 20px;
    color: #fff;
    &:first-child {
      margin-left: 0;
    }
    &:hover {
      color: #eee !important;
    }
    &:active {
      color: #fff !important;
    }
    &:visited {
      color: #ffffff !important;
    }
  }
  &-logo {
    margin-left: 10px;
    @media screen and (max-width: 767px) {
      margin-left: auto;
    }
  }
  &-links {
    margin-left: 30px;
    @media screen and (max-width: 767px) {
      margin-left: 0;
      width: 90%;
    }
  }
  .copyright {
    padding: 0;
    @media screen and (max-width: 767px) {
      order: 1;
    }
  }
  .dev {
    @media screen and (max-width: 767px) {
      order: 2;
      display: inline-block;
    }
  }
  .footer-container {
    padding: 6px 0 5px;
    width: 100%;
    display: flex;
    align-items: center;
    @media screen and (max-width: 767px) {
      flex-wrap: wrap;
    }
    @media screen and (max-width: 576px) {
      padding: 10px 15px;
    }
  }
}

.footer-links {
  margin-left: auto;
  @media screen and (max-width: 767px) {
    margin-left: 0;
  }
}
</style>
